import { useCallback } from 'react';
import useCallbackAsync from 'hooks/useCallbackAsync';
import dataRoomApi from '../dataRoomApi';
import { DataRoomRFI } from '../models/DataRoomRfi';

const useRfiRename = (
  rfi: DataRoomRFI,
  onRfiUpdate?: (rfi: DataRoomRFI) => void,
) => {
  const { _id } = rfi || {};

  const applyRename = useCallback(
    async (name: string) => {
      const { data } = await dataRoomApi.rfi.patchRfi(_id, { name });

      onRfiUpdate?.(data);
    },
    [_id, onRfiUpdate],
  );

  return useCallbackAsync(applyRename);
};

export default useRfiRename;
